import { createAsyncThunk } from "@reduxjs/toolkit";
import { appServices, IAppLocalStorage } from "../../services/app.services";
import { IFailedRequest } from "../../services/login.services";

export const initialize = createAsyncThunk<
  IAppLocalStorage,
  void,
  {
    rejectValue: IFailedRequest;
  }
>("app/initialize", async (_, thunkAPI) => {
  try {
    const response = await appServices.initialize();
    return response;
  } catch (err) {
    return thunkAPI.rejectWithValue((err as unknown) as IFailedRequest);
  }
});
